// extracted by mini-css-extract-plugin
export default {"container":"Offline_container__O-iT-"};